import React from "react";

// LOCAL COMPONENTS
import AttachmentLink from "./parts/AttachmentLink";
import AttachmentUpload from "./parts/AttachmentUpload";

// MAIN COMPONENT
const Attachment = ({
  readonly,
  ...props
}) => readonly ? <Attachment.Link {...props} /> : <AttachmentUpload {...props} />

// CHILD COMPONENTS
Attachment.Link = AttachmentLink;
Attachment.Upload = AttachmentUpload;

// EXPORT
export default Attachment